export const getParamValue = (
  params,
  key: string,
  storageKey: string,
  defaultValue: string
) => {
  return params[key] || localStorage.getItem(storageKey) || defaultValue;
};

export const defaultParams = {
  agentcode: "1469",
  utm_source: "Direct+Marketing",
  utm_medium: "cpc",
  utm_campaign: "Direct+Marketing",
  utm_id: "30101001",
  utm_query: "best pos in ksa",
  utm_content: "carousel",
  fbclid: "IwAR2fFz9aNXYZ12345XABC67890GhIJKLmnopqr",
  gclid:
    "Cj0KCQiA_bieBhDSARIsADU4zLeRt7EFjJyx5VRdZmTu_XWSTkXq89BOpTqztQuo7EChFnH0WtHhEikaAhq6EALw_wcB",
};
